import { ISeasonStanding } from '../../../../store/player/standings/store';

import { IParsedStanding } from '../../../../components/LeaderBoard/LeaderBoard';

interface IByPlayer {
  [userId: number]: IParsedStanding;
}

export const parseStandings = (standings: ISeasonStanding[]): IParsedStanding[] =>
  Object.values(
    standings.reduce(
      (byPlayer: IByPlayer, standing: ISeasonStanding) => {
        const rows = (byPlayer[standing.userId] ? byPlayer[standing.userId].rows : []).concat([
          { name: standing.eventName, id: standing.eventId, points: Number(standing.points) || 0 }
        ]);

        return {
          ...byPlayer,
          [standing.userId]: {
            firstName: standing.userFirstName,
            img: standing.userImage,
            lastName: standing.userLastName,
            points: rows.reduce((acc: number, e: any) => acc + e.points, 0),
            rows
          }
        };
      },
      ({} as any) as IByPlayer
    )
  ).sort((a: any, b: any) => (a.points < b.points ? 1 : -1));
